module.exports = __webpack_public_path__ + "static/media/PGL02@m.49fb92fe.jpg";